const Container = ({
    children, classes
}) => {
    return (
        <div className={`max-w-[1420px] mx-auto px-4 ${classes}`}>{children}</div>
    );
};

export default Container;